var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28.001,
    viewBox: "0 0 27 28.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order_history",
    transform: "translate(11816 -581.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M16,28H3a3,3,0,0,1-3-3V23a1,1,0,0,1,1-1H2V4A4,4,0,0,1,6,0H18.232C19.621,0,23,.1,24.378,1.038a6.011,6.011,0,0,1,.09,9.866A5.983,5.983,0,0,1,19,11.65V25A3,3,0,0,1,16,28ZM2,24v1a1,1,0,0,0,1,1H13.184A2.959,2.959,0,0,1,13,25V24ZM7,14a1,1,0,1,0,0,2h7a1,1,0,1,0,0-2Zm0-4a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2ZM21,2a4,4,0,1,0,4,4A4,4,0,0,0,21,2ZM7,6A1,1,0,0,0,7,8h4a1,1,0,0,0,0-2ZM23,7H21a1,1,0,0,1-1-1V5a1,1,0,1,1,2,0h1a1,1,0,0,1,0,2Z",
    transform: "translate(-11816 582)",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order_history.9be7811740ca658fabf9df8980710b0c.svg";
export { ForwardRef as ReactComponent };